module.exports = __webpack_public_path__ + "static/media/alice-naar-c_c5hd-9iwY-unsplash.198364e7.jpg";